<template>
  <div>
    <v-navigation-drawer v-model="drawer" app clipped temporary>
      <v-list dense>
        <v-list-item link to="/">
          <v-list-item-action>
            <v-icon>{{ 'home' }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Main</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/video" v-if="role == 'ADMIN'">
          <v-list-item-action>
            <v-icon>{{ 'video_library' }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Sessions Library</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/stickers" v-if="role == 'ADMIN'">
          <v-list-item-action>
            <v-icon>{{ 'whatshot' }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Stickers Library</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/splashscreen" v-if="role == 'ADMIN'">
          <v-list-item-action>
            <v-icon>{{ 'add_to_home_screen' }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Splashscreens Library</v-list-item-title>
          </v-list-item-content>
        </v-list-item>     
        <v-list-item link to="/users" v-if="role == 'ADMIN'">
          <v-list-item-action>
            <v-icon>{{ 'account_box' }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Magby users</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/statistics">
          <v-list-item-action>
            <v-icon>{{ 'attach_money' }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Sales Statistics</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/coupon" v-if="role == 'ADMIN'">
          <v-list-item-action>
            <v-icon>{{ 'receipt' }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Coupon</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/card" v-if="role == 'ADMIN'">
          <v-list-item-action>
            <v-icon>{{ 'credit_card' }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Card</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-list class="pa-0">
          <v-list-item link @click="logoutMethod()">
            <v-list-item-action>
              <v-icon>{{ 'logout' }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-app-bar app clipped-left class="elevation-0" color="#fff">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-list-item-content v-if="$route.path !== '/statistics'">
        <v-tabs 
          center-active 
          background-color="transparent"
          color="primary"
        >
          <v-tab @click="changeTab('')">All</v-tab>
          <v-tab 
            v-for="(tab, index) in terminals" 
            :key="index" 
            @click="changeTab(tab)"
          >
            {{ tab.name }}
          </v-tab>
        </v-tabs>
      </v-list-item-content>
    </v-app-bar>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: 'Navbar',
  data: () => ({
    drawer: false
  }),
  computed: {
    ...mapState('terminals', ['activeTerminal', 'terminals']),
    ...mapGetters('user', ['role'])
  },
  methods: {
    ...mapMutations('terminals', ['setActiveTerminal']),
    ...mapActions('user', ['logout']),
    changeTab(terminal) {
      this.setActiveTerminal(terminal.name ? terminal.name : "")
    },
    logoutMethod() {
      this.logout().then(() => {
        this.$router.push("/login");
      });
    },
  }
};
</script>